import { Button, Icon, Paper } from '@material-ui/core';
import React, { useEffect } from 'react';
import Loader from 'react-overlay-loader/lib/Loader';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchVenueDetails } from '../../../../actions/venue/index';
import './index.scss';

const SetupStep = ({
  fetchVenueDetails,
  number,
  title,
  subtitle,
  description,
  icon,
  buttonName,
  onAction,
  secondaryAction,
  completed,
  secondaryButton,
}) => (
  <div className="setup__step">
    <div
      style={{ alignItems: completed ? 'center' : '' }}
      className="setup__step__information"
    >
      <div className="setup__step__information__number">{number}</div>
      <div className="setup__step__information__details">
        <div className="setup__step__information__details__header">{title}</div>
        {number == 3 && (
          <p className="optional_for_reservations">
            (Optional for reservations)
          </p>
        )}
        {!completed && (
          <React.Fragment>
            <div className="setup__step__information__details__subtitle">
              <Icon className="setup__step__information__icon">{icon}</Icon>
              {subtitle}
            </div>
            <div className="setup__step__information__details__desc">
              {description}
            </div>
          </React.Fragment>
        )}
      </div>
      {!completed && (
        <Button className="setup__step__button fatsoma__cta" onClick={onAction}>
          {buttonName}
        </Button>
      )}
      {secondaryButton && (
        <Button
          className="setup__step__button fatsoma__cta"
          onClick={secondaryAction}
        >
          {secondaryButton}
        </Button>
      )}

      {completed && (
        <Icon className="setup__step__complete__icon">check_circle</Icon>
      )}
    </div>
  </div>
);

const SetupPanel = ({ venue, history, fetchVenueDetails }) => {
  useEffect(() => {
    fetchVenueDetails();
  }, []);

  return (
    <div className="panel__content">
      <h3>Welcome to Fatsoma Tabb</h3>
      <p className="no__margin__top">
        Complete these steps to get up and running.
      </p>

      {venue.has_visited_settings &&
      venue.stripe_token &&
      venue.stripe_token !== '' ? (
        <div className="banner-wrapper">
          <div className="header-wrapper">
            <p className="banner-text">
              You can now take reservations and deposits from your customers
            </p>
          </div>
          <div className="button-wrapper">
            <button className="go-to-res-btn">
              <Link to={`/dashboard/bookings/`} className="text-none">
                Go to Reservations
              </Link>
            </button>
          </div>
        </div>
      ) : null}

      <Paper className="setup__steps__container" elevation={1}>
        <SetupStep
          number={1}
          completed={venue.has_visited_settings}
          title="Setup your booking page"
          subtitle="ABOUT 5-10 MIN"
          description="Add a header image and description to your booking page."
          icon="settings"
          buttonName="Check your venue settings"
          onAction={() => history.push('/dashboard/settings')}
        />
        <SetupStep
          number={2}
          completed={venue.stripe_token && venue.stripe_token !== ''}
          title="Connect Stripe"
          subtitle="ABOUT 10 MIN"
          description="Connect a Stripe account so you can take payments."
          icon="account_balance"
          buttonName="Connect your Stripe account"
          onAction={() => history.push('/dashboard/financial/connect')}
        />

        <SetupStep
          number={3}
          completed={venue.has_created_menu}
          title="Add your Menu"
          subtitle="ABOUT 5-10 MIN"
          description="Allow customers to add food and drink to their orders."
          icon="local_dining"
          buttonName="Add your Menu"
          onAction={() => history.push('/dashboard/menus')}
        />
        <SetupStep
          number={4}
          completed={venue.has_first_order}
          title="Take your first order"
          description="Get customers to your Tabb page and take your first order."
          icon="live_tv"
          buttonName="Start Taking Deposits"
          secondaryButton="View order & pay orders"
          secondaryAction={() => history.push('/dashboard/live')}
          onAction={() => history.push('/dashboard/bookings')}
        />

        <Loader loading={venue.fetchingVenue} />
      </Paper>
    </div>
  );
};

const mapStateToProps = state => ({
  venue: state.venue,
});

const mapDispatchToProps = dispatch => ({
  fetchVenueDetails: () => dispatch(fetchVenueDetails()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SetupPanel);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Setup/index.jsx